// extracted by mini-css-extract-plugin
export default {"noData":"noData__style-OhLwr_Ck","text":"text__style-3dC5-87i"};